import FileCard from "./FileCard";

interface Props {
  files: File[];
  onRemove: (index: number) => void;
  disabled: boolean;
}

export default function FilePickerPreview({ files, onRemove, disabled }: Props) {
  if (files.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {files.map((file, index) => (
        <FileCard
          key={`${file.name}-${index}`}
          name={file.name}
          size={file.size}
          contentType={file.type}
          onRemove={() => onRemove(index)}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
